import { render, staticRenderFns } from "./smstemp.vue?vue&type=template&id=0afa228a&scoped=true&"
import script from "./smstemp.vue?vue&type=script&lang=js&"
export * from "./smstemp.vue?vue&type=script&lang=js&"
import style0 from "./smstemp.vue?vue&type=style&index=0&id=0afa228a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa228a",
  null
  
)

export default component.exports